import type { Sequence } from "../types/Sequence"

export function Reduce<T, A>(
  func: (accumulator: A, item: T, index: number) => A,
  sequence: Sequence<T>,
  initial: A
): A {
  let accumulator = initial
  let index = 0

  for (const item of sequence) {
    accumulator = func(accumulator, item, index++)
  }

  return accumulator
}
